// eslint-disable-next-line no-unused-vars
import { BookingStatus } from './BookingStatus'

/**
 * A booking status enum that simplifies the categorisation of bookings into more
 * meaningful and useful groups.
 */
export default Object.freeze({
  /**
   * A booking that requires approval from a privileged user.
   * Bookings created by a user that has the pending approval permission.
   * Translates to status: {@link BookingStatus.BOOKING_PENDING_REQUIRES_CLIENT_APPROVAL}
   */
  pendingApproval: 'pendingApproval',
  /**
   * A booking filled with a candidate and has been confirmed with the client and
   * is not tentative (status: {@link BookingStatus.TENTATIVE_FILLED}).
   */
  filled: 'filled',
  /**
   * A booking that is tentatively filled.
   * Translates to status: {@link BookingStatus.TENTATIVE_FILLED}
   */
  tentative: 'tentative',
  /**
   * Any booking that is not filled with a candidate and doesn't fit into any other
   * category
   */
  unfilled: 'unfilled',
  /**
   * The booking was pending approval by client and was rejected.
   * Translates to status: {@link BookingStatus.CLIENT_REJECTED_BOOKING_REQUEST}
   */
  rejected: 'rejected',
})
